import {
  addObj,
  getAll,
  getPage,
  getDetail,
  modifyObj,
  deleteObj
} from '@/api/incomeserv'

export default {
  state: {
    state_Income_AddObjResult: null,
    state_Income_GetAllResult: null,
    state_Income_GetPageResult: null,
    state_Income_GetDetailResult: null,
    state_Income_ModifyObjResult: null,
    state_Income_DeleteObjResult: null
  },
  mutations: {
    SET_INCOME_ADDOBJ_RESULT: (state, rst) => {
      state.state_Income_AddObjResult = rst
    },
    SET_INCOME_GETALL_RESULT: (state, rst) => {
      state.state_Income_GetAllResult = rst
    },
    SET_INCOME_GETPAGE_RESULT: (state, rst) => {
      state.state_Income_GetPageResult = rst
    },
    SET_INCOME_GETDETAIL_RESULT: (state, rst) => {
      state.state_Income_GetDetailResult = rst
    },
    SET_INCOME_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_Income_ModifyObjResult = rst
    },
    SET_INCOME_DELETEOBJ_RESULT: (state, rst) => {
      state.state_Income_DeleteObjResult = rst
    }
  },
  actions: {
    IncomeServ_AddObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INCOME_ADDOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INCOME_ADDOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    IncomeServ_GetAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INCOME_GETALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INCOME_GETALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    IncomeServ_GetPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INCOME_GETPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INCOME_GETPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    IncomeServ_GetDetail ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INCOME_GETDETAIL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INCOME_GETDETAIL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    IncomeServ_ModifyObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INCOME_MODIFYOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INCOME_MODIFYOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    IncomeServ_DeleteObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INCOME_DELETEOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INCOME_DELETEOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  getters: {
    get_Income_AddObjResult: state => {
      return state.state_Income_AddObjResult
    },
    get_Income_GetAllResult: state => {
      return state.state_Income_GetAllResult
    },
    get_Income_GetPageResult: state => {
      return state.state_Income_GetPageResult
    },
    get_Income_GetDetailResult: state => {
      return state.state_Income_GetDetailResult
    },
    get_Income_ModifyObjResult: state => {
      return state.state_Income_ModifyObjResult
    },
    get_Income_DeleteObjResult: state => {
      return state.state_Income_DeleteObjResult
    }
  }
}
